import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { useUserStore } from '@/store/user';
import { ref, computed } from 'vue';
import ModalAuth from './ModalAuth.vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();
const authenticated = computed(() => !!userStore.me);
const router = useRouter();

const isShowModalAuth = ref(false);
const connectWallet = () => {
  router.push('/landing/auth');
  // isShowModalAuth.value = true;
};

const modalContentStyle = (width = 'unset') => ({
  width: '100vw',
  'max-width': width,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({
      connectWallet: connectWallet,
      userStore: _unref(userStore),
      authenticated: _unref(authenticated),
      logout: _unref(userStore).logout,
    }))),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(ModalAuth, {
        modelValue: isShowModalAuth.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShowModalAuth).value = $event)),
        "content-style": modalContentStyle('427px')
      }, null, 8, ["modelValue", "content-style"])
    ]))
  ], 64))
}
}

})